var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "features",
      class: {
        isScrolledIntoView:
          _vm.isLoaded && _vm.isReflowed && _vm.isScrolledIntoView
      }
    },
    [
      _vm.isLoaded
        ? _c("div", { staticClass: "features-inner" }, [
            _vm.featuresHeading
              ? _c("h2", { staticClass: "heading" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.featuresHeading) +
                      "\n        "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "slick" },
              _vm._l(_vm.posts.slice(0, _vm.featuresMaxItems), function(post) {
                return _c("div", [
                  _c(
                    "div",
                    {
                      staticClass: "item",
                      on: {
                        click: function($event) {
                          _vm.slickItemClickHandler(
                            _vm.wpApi.stripBaseUrl(post["link"])
                          )
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "aspect-ratio-box item-image" },
                        [
                          _c("div", { staticClass: "aspect-ratio-box-inner" }, [
                            _c("div", { staticClass: "diamond-box" }, [
                              _c("div", { staticClass: "diamond-box-inner" }, [
                                post["acf"]["teaser_image_720_720"]
                                  ? _c("img", {
                                      attrs: {
                                        alt:
                                          post["acf"]["teaser_image_alt_text"],
                                        src: _vm.wpApi.stripHost(
                                          post["acf"]["teaser_image_720_720"]
                                        )
                                      }
                                    })
                                  : _vm._e()
                              ])
                            ])
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("h4", {
                        staticClass: "item-heading",
                        domProps: {
                          innerHTML: _vm._s(post["acf"]["teaser_title"])
                        }
                      }),
                      _vm._v(" "),
                      _c("p", {
                        staticClass: "item-text",
                        domProps: {
                          innerHTML: _vm._s(post["acf"]["teaser_copy"])
                        }
                      }),
                      _vm._v(" "),
                      _vm._m(0, true)
                    ]
                  )
                ])
              }),
              0
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "item-action" }, [
      _c(
        "button",
        {
          staticClass:
            "btn btn-white-pink-black-white ani-btn-hover-scale-bounce"
        },
        [
          _vm._v(
            "\n                            mehr erfahren\n                        "
          )
        ]
      )
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6575d390", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6575d390","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/Features.vue
// module id = 613
// module chunks = 0